import React from "react";
import PropTypes from "prop-types";

const Tabs = ({ activeId, label, onChange, tabs }) => {  const moveFocus = (event) => {
    const buttons = [...event.currentTarget.querySelectorAll('[role="tab"]:not(:disabled)')];
    const currentIndex = buttons.indexOf(document.activeElement);
    let nextIndex;

    if (event.key === "ArrowRight") nextIndex = (currentIndex + 1) % buttons.length;
    if (event.key === "ArrowLeft") nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    if (event.key === "Home") nextIndex = 0;
    if (event.key === "End") nextIndex = buttons.length - 1;

    if (nextIndex !== undefined) {
      event.preventDefault();
      buttons[nextIndex]?.focus();
    }
  };
  return (
    <div className="wsm-tabs">
      <div aria-label={label} onKeyDown={moveFocus} role="tablist">
        {tabs?.map((tab) => {
          const selected = tab.id === activeId;
          return (
            <button
              aria-selected={selected}
              disabled={tab.disabled}
              key={tab.id}
              onClick={() => onChange(tab.id)}
              role="tab"
              tabIndex={selected ? 0 : -1}
              type="button"
            >
              <span>{tab.label}</span>
              {tab.count !== undefined && <strong aria-label={`${tab.count} items`}>{tab.count}</strong>}
            </button>
          );
        })}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  activeId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({ count: PropTypes.number, disabled: PropTypes.bool, id: PropTypes.string.isRequired, label: PropTypes.string.isRequired })).isRequired,
};

export default Tabs;
